// extracted by mini-css-extract-plugin
export default {"panel":"styles__panel___V3dB9","title":"styles__title___eJzYW","description":"styles__description___W0qMx"};